import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import MainImageCardDashboard from '../../../components/Cards/MainImageCardDashboard';
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import PsychologyIcon from '@mui/icons-material/Psychology';
import { neuro } from "../../../constants";


export default function NeuroCard() {

return (
<>

    <MainImageCardDashboard

        content = {<HeaderCardSmall cardheadline={'Neurology Health'} /> }

        iconbuttons = {<>               

                        <Tooltip title="Neurology Health" placement="bottom">
                                <IconButton component={RouterLink} to="/NeuroWelcome" >
                                        <PsychologyIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
                                </IconButton>
                        </Tooltip>               
                 </>}  

        photo = { neuro }  

    />

</>
)};
